import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getReferralRewards } from "../../redux/pricing-plan/action";

function UseFetchReferralRewards() {
  const {
    main: { userData },
    pricingPlan: {
      referralRewardsLoading,
      referralRewardsFetched,
      referralRewardsError,
    },
  } = useSelector((state) => state);

  const dispatch = useDispatch();

  useEffect(() => {
    if (
      userData?.email &&
      !referralRewardsLoading &&
      !referralRewardsError &&
      !referralRewardsFetched
    ) {
      return dispatch(
        getReferralRewards(
          userData?.email,
          userData?.["custom:custom_username"],
        ),
      );
    }
  }, [
    dispatch,
    referralRewardsError,
    referralRewardsFetched,
    referralRewardsLoading,
    userData?.email,
  ]);

  return null;
}

export default UseFetchReferralRewards;
